export default {

    //成功码
    SUCCESS_CODE : 0,
    localLangage:'local-langage',//本地化语言 
    token:"token",
    lang:"lang",
    brandKey:"brandKey",
    // brand:"aigosmart",//品牌 
    // TenantId:'1000',//aigo
    // source:"aigosmartHome",

      brand:"Wisdomleads",//公版
     TenantId:'1001',//公版
    source:"Wisdomleads",
   }

//    export  const  SUCCESS_CODE = 0